var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"msgArea"},[_c('div',{on:{"click":_vm.goNext}},[_c('MessageWindow',{attrs:{"name":"","text":'これは分身体だった！\n他の場所をまわろう！',"lock":false,"bgcolor":'#000000'}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }